import { createContext } from 'react';

export const ToFollowContext = createContext(null)